import { useTranslation } from 'next-i18next'

import { Icon } from '~/components/Icon'
import { GameTagName } from '~/games/types/games.types'

export function GameTag({
  bg,
  color,
  name,
  iconName,
}: {
  bg: string
  color: string
  name: GameTagName
  iconName?: string
}): React.ReactElement {
  const { t } = useTranslation('games')
  const tagClass = 'py-1 px-1 flex items-center rounded text-tag'
  return (
    <div className={`${tagClass} ${bg} ${color}`}>
      {iconName && <Icon alt={t(name)} className="text-2.5" customImageSrc={iconName} />}
      <span className="leading-none font-bold mx-1.5">{t(name)}</span>
    </div>
  )
}
